var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner-row input-dialog" },
    [
      _c(
        "el-form",
        {
          staticStyle: { width: "100%", height: "800px" },
          attrs: { "label-position": "right", "label-width": "120px" }
        },
        [
          _c(
            "el-row",
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "700px",
                  height: "200px",
                  "padding-bottom": "5px"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.titleGrid.gridOptions,
                  "column-defs": _vm.titleGrid.titleColumnDefs,
                  "row-data": _vm.titleGrid.rowData
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.titleGrid.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ReceiptInvoiceChannel"),
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        no: "inputTaxInvoiceChannel",
                        disabled: !_vm.isEdit
                      },
                      on: { change: _vm.invoiceChannelChange },
                      model: {
                        value: _vm.from.inputTaxInvoiceChannel,
                        callback: function($$v) {
                          _vm.$set(_vm.from, "inputTaxInvoiceChannel", $$v)
                        },
                        expression: "from.inputTaxInvoiceChannel"
                      }
                    },
                    _vm._l(_vm.SystemConstants.INVOICE_CHANNEL_STATUS, function(
                      item
                    ) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.chineseName, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.isNuoNuo
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "APPkey", required: "" } },
                        [
                          _c("el-input", {
                            staticClass: "input-color",
                            staticStyle: { width: "300px" },
                            attrs: {
                              no: "inputTaxAppKey",
                              disabled: !_vm.isEdit
                            },
                            model: {
                              value: _vm.from.inputTaxAppKey,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "inputTaxAppKey", $$v)
                              },
                              expression: "from.inputTaxAppKey"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "APPSecret", required: "" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              no: "inputTaxAppSecret",
                              disabled: !_vm.isEdit
                            },
                            model: {
                              value: _vm.from.inputTaxAppSecret,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "inputTaxAppSecret", $$v)
                              },
                              expression: "from.inputTaxAppSecret"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Token", required: "" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              no: "inputTaxToken",
                              disabled: !_vm.isEdit
                            },
                            model: {
                              value: _vm.from.inputTaxToken,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "inputTaxToken", $$v)
                              },
                              expression: "from.inputTaxToken"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }